<template>
  <v-app class="pa-0 list_sidebar">
    <div id="navbar">
      <v-app-bar
        id="navbar"
        light
        fixed
        src="./assets/img/barra.jpg"
        height="45px"
      >
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          v-if="isLoggedIn"
          class="hidden-md-and-up"
        ></v-app-bar-nav-icon>
        <img :src="require('./assets/img/icon/software-icon.png')" class="logo" />

        <v-spacer></v-spacer>
      </v-app-bar>
    </div>
    <div  id="sidebar">
      <v-navigation-drawer
        v-model="drawer"
        absolute
        :permanent="!isMobile"
        :temporary="isMobile"
        v-if="isLoggedIn"
        :color="$systemcolor"
      >
        <sidebar />
      </v-navigation-drawer>
    </div>
    <div id="content" :class="isLoggedIn ? 'content' : 'unlogged'">
      <v-card
        :class="isLoggedIn ? 'bg-rp' : 'bg-tr'"
        :flat="!isLoggedIn"
        class="overflow-y-auto overflow-x-hidden"
        height="100%"
      >
        <router-view></router-view>
      </v-card>
    </div>
    <div id="footer" class="footer text-caption" v-if="isLoggedIn">
      &copy; {{copyright }}
    </div>
    <sea-snackbar></sea-snackbar>
    <cookie-law
      theme="base"
      :message="cookieMessage"
      buttonText="Autorizzo"
    ></cookie-law>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import CookieLaw from "vue-cookie-law";
import Sidebar from "@/components/Sidebar";
import { APPLICATION_NAME, colors, copyright } from "@/constants";


const cookieMessage =
  "Per offrirti il miglior servizio possibile questo sito utilizza cookies. Continuando la navigazione nel sito autorizzi l'uso dei cookies.";

export default {
  name: "App",
  created() {
    document.title = APPLICATION_NAME;
  },
  components: {
    Sidebar,
    CookieLaw,
    
  },

  data: () => {
    return { cookieMessage, drawer: false, colors, copyright };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "account/authenticated",
      account: "account/account",
    }),
    isMobile() {
      return (
        this.$vuetify.breakpoint.name === "xs" ||
        this.$vuetify.breakpoint.name === "sm"
      );
    },
  },
  watch: {
    isMobile() {
      this.drawer = !this.isMobile;
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/variables.scss";

@mixin layout($sideWidth) {
  .content,
  .footer {
    left: $sideWidth;
  }
}

@media only screen and (max-width: 960px) {
  @include layout($sideWidth: 0);
}
@media only screen and (min-width: 960px) {
  @include layout($sideWidth: $sideBarWidth);
}

#navbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: $navbarHeigth;
}

#sidebar {
  position: absolute;
  top: $navbarHeigth;
  left: 0;
  bottom: 0;
  width: $sideBarWidth;
}

#content {
  position: absolute;
  right: 0;
  top: $navbarHeigth;
}

#footer {
  position: absolute;
  right: 0;
  bottom: 0;
  height: $footerHeight;
  background-color: $systemcolor;
  text-align: center;
  font-weight: bold;
  color: #fff;
}

.content {
  bottom: $footerHeight;
  background-color: $systemcolor;
  padding: 8px;
}

.unlogged {
  left: 0;
  bottom: 0;
  background-image: url("assets/img/background/bg.png");
  background-size: cover;
}

.logo {
  position: fixed;
  top: 5px;
  left: 60px;
  height: 47px;
  width: 150px;
  height: auto;
}

.bgcol1,
.bgcol3 {
  background-color: $systemcolor;
}
.bgcol2 {
  background-image: linear-gradient(to right, $systemcolor, #fff);
}
.bglogin {
  background-image: url("assets/img/background/bg.png");
  background-size: cover;
}

.bg-tr {
  background-color: transparent !important;
}
.dd {
  background-color: rebeccapurple;
}
</style>


